(function () {
  'use strict';

  var CONFIG_ID = 'asos-wishlist-sync-config';
  var LOCAL_KEY = 'wishlistItem';
  var TOKEN_KEY = 'asosWishlistAccessToken';
  var TOKEN_EXPIRY_KEY = 'asosWishlistAccessTokenExpiry';
  var OAUTH_STATE_KEY = 'asosWishlistOauthState';
  var VERIFIER_KEY = 'asosWishlistCodeVerifier';
  var RETURN_KEY = 'asosWishlistReturnPath';
  var MERGE_RELOAD_KEY = 'asosWishlistMergeReloaded';

  function readConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[A Sós wishlist] configuração inválida', error);
      return null;
    }
  }

  function uniqueHandles(values) {
    if (!Array.isArray(values)) return [];
    return values
      .filter(function (value) { return typeof value === 'string' && value.trim(); })
      .map(function (value) { return value.trim(); })
      .filter(function (value, index, list) { return list.indexOf(value) === index; });
  }

  function readLocalWishlist() {
    try {
      return uniqueHandles(JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]'));
    } catch (error) {
      return [];
    }
  }

  function writeLocalWishlist(handles) {
    var list = uniqueHandles(handles);
    localStorage.setItem(LOCAL_KEY, JSON.stringify(list));
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = list.length > 0 ? String(list.length) : '';
      var bubble = node.closest('.wishlist-count-bubble');
      if (bubble) bubble.classList.toggle('is-visible', list.length > 0);
    });
    return list;
  }

  function mergeLists(a, b) {
    return uniqueHandles((a || []).concat(b || []));
  }

  function sameList(a, b) {
    var left = uniqueHandles(a).slice().sort();
    var right = uniqueHandles(b).slice().sort();
    return left.length === right.length && left.every(function (value, index) { return value === right[index]; });
  }

  function base64UrlEncode(bytes) {
    var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }

  function randomValue() {
    var bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return base64UrlEncode(bytes);
  }

  async function createCodeChallenge(verifier) {
    var digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return base64UrlEncode(new Uint8Array(digest));
  }

  async function discoverAuth(origin) {
    var response = await fetch(origin + '/.well-known/openid-configuration', { credentials: 'omit' });
    if (!response.ok) throw new Error('Não foi possível descobrir os endpoints de autenticação.');
    return response.json();
  }

  async function discoverApi(origin) {
    var response = await fetch(origin + '/.well-known/customer-account-api', { credentials: 'omit' });
    if (!response.ok) throw new Error('Não foi possível descobrir o endpoint da conta da cliente.');
    return response.json();
  }

  function getCallbackUrl(config) {
    return config.callbackUrl || (window.location.origin + (config.wishlistPath || '/pages/wishlist'));
  }

  function getAccountOrigin(config) {
    try {
      return new URL(getCallbackUrl(config)).origin;
    } catch (error) {
      return window.location.origin;
    }
  }

  function getAccessToken() {
    var token = sessionStorage.getItem(TOKEN_KEY);
    var expiry = Number(sessionStorage.getItem(TOKEN_EXPIRY_KEY) || 0);
    if (!token || !expiry || Date.now() >= expiry) {
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(TOKEN_EXPIRY_KEY);
      return null;
    }
    return token;
  }

  function storeAccessToken(payload) {
    if (!payload || !payload.access_token) return;
    var ttl = Math.max(Number(payload.expires_in || 0) - 60, 60);
    sessionStorage.setItem(TOKEN_KEY, payload.access_token);
    sessionStorage.setItem(TOKEN_EXPIRY_KEY, String(Date.now() + (ttl * 1000)));
    sessionStorage.removeItem('asosWishlistSilentAuthTried');
  }

  async function beginAuthorization(config, prompt) {
    if (!config || !config.clientId) return false;

    var origin = getAccountOrigin(config);
    var authConfig = await discoverAuth(origin);
    var verifier = randomValue();
    var challenge = await createCodeChallenge(verifier);
    var state = randomValue();
    var redirectUri = getCallbackUrl(config);
    var url = new URL(authConfig.authorization_endpoint);

    sessionStorage.setItem(VERIFIER_KEY, verifier);
    sessionStorage.setItem(OAUTH_STATE_KEY, state);
    sessionStorage.setItem(RETURN_KEY, window.location.pathname + window.location.search + window.location.hash);

    url.searchParams.set('scope', 'openid email customer-account-api:full');
    url.searchParams.set('client_id', config.clientId);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', redirectUri);
    url.searchParams.set('state', state);
    url.searchParams.set('nonce', randomValue());
    url.searchParams.set('code_challenge', challenge);
    url.searchParams.set('code_challenge_method', 'S256');
    if (prompt) url.searchParams.set('prompt', prompt);

    window.location.assign(url.toString());
    return true;
  }

  async function exchangeAuthorizationCode(config, code) {
    var verifier = sessionStorage.getItem(VERIFIER_KEY);
    if (!verifier) throw new Error('Verificador de autenticação ausente.');

    var origin = getAccountOrigin(config);
    var authConfig = await discoverAuth(origin);
    var body = new URLSearchParams();
    body.set('grant_type', 'authorization_code');
    body.set('client_id', config.clientId);
    body.set('redirect_uri', getCallbackUrl(config));
    body.set('code', code);
    body.set('code_verifier', verifier);

    var response = await fetch(authConfig.token_endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: body
    });

    if (!response.ok) throw new Error('Não foi possível concluir a autenticação da lista de desejos.');
    var payload = await response.json();
    storeAccessToken(payload);
    sessionStorage.removeItem(VERIFIER_KEY);
    sessionStorage.removeItem(OAUTH_STATE_KEY);
    return payload.access_token;
  }

  async function customerApi(config, token, query, variables) {
    var apiConfig = await discoverApi(getAccountOrigin(config));
    var response = await fetch(apiConfig.graphql_api, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    });

    if (response.status === 401) {
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(TOKEN_EXPIRY_KEY);
      throw new Error('Sessão da lista de desejos expirada.');
    }

    if (!response.ok) throw new Error('Falha ao acessar a lista de desejos da conta.');
    var payload = await response.json();
    if (payload.errors && payload.errors.length) throw new Error(payload.errors[0].message || 'Erro na lista de desejos.');
    return payload.data;
  }

  function parseRemoteWishlist(metafield) {
    if (!metafield || !metafield.value) return [];
    try {
      return uniqueHandles(JSON.parse(metafield.value));
    } catch (error) {
      return [];
    }
  }

  async function readRemoteWishlist(config, token) {
    var query = 'query WishlistCustomer { customer { id metafield(namespace: "custom", key: "wishlist") { value } } }';
    var data = await customerApi(config, token, query);
    if (!data || !data.customer) throw new Error('Cliente autenticada não encontrada.');
    return {
      customerId: data.customer.id,
      handles: parseRemoteWishlist(data.customer.metafield)
    };
  }

  async function writeRemoteWishlist(config, token, customerId, handles) {
    var mutation = 'mutation SaveWishlist($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { metafields { key value } userErrors { field message code } } }';
    var variables = {
      metafields: [{
        ownerId: customerId,
        namespace: 'custom',
        key: 'wishlist',
        type: 'list.single_line_text_field',
        value: JSON.stringify(uniqueHandles(handles))
      }]
    };
    var data = await customerApi(config, token, mutation, variables);
    var errors = data && data.metafieldsSet && data.metafieldsSet.userErrors;
    if (errors && errors.length) throw new Error(errors[0].message || 'Não foi possível salvar os favoritos.');
  }

  async function initialSync(config, token) {
    var remote = await readRemoteWishlist(config, token);
    var local = readLocalWishlist();
    var merged = mergeLists(remote.handles, local);
    if (!sameList(remote.handles, merged)) {
      await writeRemoteWishlist(config, token, remote.customerId, merged);
    }
    var changedLocally = !sameList(local, merged);
    writeLocalWishlist(merged);
    return changedLocally;
  }

  async function persistCurrentLocalWishlist(config) {
    var token = getAccessToken();
    if (!token) return;
    try {
      var remote = await readRemoteWishlist(config, token);
      await writeRemoteWishlist(config, token, remote.customerId, readLocalWishlist());
    } catch (error) {
      console.warn('[A Sós wishlist] sincronização adiada', error);
    }
  }

  function mergeLiquidWishlist(config) {
    var initial = uniqueHandles(config.initialWishlist || []);
    if (!initial.length) return false;
    var local = readLocalWishlist();
    var merged = mergeLists(initial, local);
    if (sameList(local, merged)) return false;
    writeLocalWishlist(merged);
    return true;
  }

  function isWishlistPage(config) {
    var path = config.wishlistPath || '/pages/wishlist';
    return window.location.pathname.replace(/\/$/, '') === path.replace(/\/$/, '');
  }

  async function handleCallback(config) {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var state = params.get('state');
    var error = params.get('error');

    if (error) {
      sessionStorage.removeItem(OAUTH_STATE_KEY);
      sessionStorage.removeItem(VERIFIER_KEY);
      return false;
    }
    if (!code) return false;

    var expectedState = sessionStorage.getItem(OAUTH_STATE_KEY);
    if (!state || !expectedState || state !== expectedState) throw new Error('Estado de autenticação inválido.');

    var token = await exchangeAuthorizationCode(config, code);
    await initialSync(config, token);

    var returnPath = sessionStorage.getItem(RETURN_KEY) || (config.wishlistPath || '/pages/wishlist');
    sessionStorage.removeItem(RETURN_KEY);
    var cleanUrl = new URL(returnPath, window.location.origin);
    window.location.replace(cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    return true;
  }

  function schedulePersist(config) {
    window.clearTimeout(schedulePersist.timer);
    schedulePersist.timer = window.setTimeout(function () {
      persistCurrentLocalWishlist(config);
    }, 250);
  }

  function persistOrAuthorize(config) {
    if (getAccessToken()) {
      schedulePersist(config);
      return;
    }
    if (!config.customerLoggedIn || sessionStorage.getItem('asosWishlistSilentAuthTried')) return;

    sessionStorage.setItem('asosWishlistSilentAuthTried', '1');
    beginAuthorization(config, 'none').catch(function (error) {
      console.warn('[A Sós wishlist] autenticação silenciosa indisponível', error);
    });
  }

  function initWishlistCounterVisibility() {
    function updateBubble(bubble) {
      if (!bubble) return;
      var node = bubble.querySelector('[data-wishlist-count]');
      var count = parseInt((node && node.textContent) || '0', 10) || 0;
      var shouldShow = count > 0;
      if (bubble.classList.contains('is-visible') !== shouldShow) {
        bubble.classList.toggle('is-visible', shouldShow);
      }
    }

    function updateNode(node) {
      if (!node || !node.matches || !node.matches('[data-wishlist-count]')) return;
      updateBubble(node.closest('.wishlist-count-bubble'));
    }

    document.querySelectorAll('.wishlist-count-bubble').forEach(updateBubble);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target && mutation.target.nodeType === 3) {
          updateNode(mutation.target.parentElement);
        } else if (mutation.target && mutation.target.matches && mutation.target.matches('[data-wishlist-count]')) {
          updateNode(mutation.target);
        } else if (mutation.type === 'attributes' && mutation.target && mutation.target.matches && mutation.target.matches('.wishlist-count-bubble')) {
          updateBubble(mutation.target);
        }

        if (mutation.addedNodes && mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function (added) {
            if (!added || added.nodeType !== 1) return;
            if (added.matches && added.matches('[data-wishlist-count]')) updateNode(added);
            if (added.querySelectorAll) added.querySelectorAll('[data-wishlist-count]').forEach(updateNode);
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  async function init() {
    initWishlistCounterVisibility();
    var config = readConfig();
    if (!config) return;

    var liquidMergeChanged = mergeLiquidWishlist(config);
    if (liquidMergeChanged && isWishlistPage(config) && !sessionStorage.getItem(MERGE_RELOAD_KEY)) {
      sessionStorage.setItem(MERGE_RELOAD_KEY, '1');
      window.location.reload();
      return;
    }
    sessionStorage.removeItem(MERGE_RELOAD_KEY);

    if (!config.clientId) return;

    try {
      if (await handleCallback(config)) return;
    } catch (error) {
      console.warn('[A Sós wishlist] callback não concluído', error);
      return;
    }

    var token = getAccessToken();
    if (token) {
      try {
        var changed = await initialSync(config, token);
        if (changed && isWishlistPage(config)) window.location.reload();
      } catch (error) {
        console.warn('[A Sós wishlist] sincronização inicial adiada', error);
      }
    } else if (config.customerLoggedIn && isWishlistPage(config) && !sessionStorage.getItem('asosWishlistSilentAuthTried')) {
      sessionStorage.setItem('asosWishlistSilentAuthTried', '1');
      try {
        await beginAuthorization(config, 'none');
        return;
      } catch (error) {
        console.warn('[A Sós wishlist] autenticação silenciosa indisponível', error);
      }
    }

    document.addEventListener('updatewishlistmail', function () { persistOrAuthorize(config); });
    window.addEventListener('storage', function (event) {
      if (event.key === LOCAL_KEY) persistOrAuthorize(config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
